var XLSX = require('xlsx');

const maxLength = 32767;
function Workbook() {
  if (!(this instanceof Workbook)) return new Workbook();
  this.SheetNames = [];
  this.Sheets = {};
}

const download = (url, name) => {
  let a = document.createElement('a');
  a.href = url;
  a.download = name ? name : 'export.xlsx';
  a.click();

  window.URL.revokeObjectURL(url);
};

const buildArrayResult = x => {
  const buf = new ArrayBuffer(x.length);
  const view = new Uint8Array(buf);
  for (let i = 0; i !== x.length; ++i) view[i] = x.charCodeAt(i) & 0xff;
  return buf;
};

const computeCellLimit = data => {
  const list = data.map(obj =>
    Object.fromEntries(
      Object.entries(obj).map(([key, value]) => {
        return [key, typeof value === 'string' ? value?.slice(0, maxLength) : value];
      })
    )
  );

  return list;
};

export const exportToExcel = (data, fileName, sheetName, bookType) => {
  if (!data) return;
  const computedData = computeCellLimit(data);
  const workBook = new Workbook();
  workBook.SheetNames.push(sheetName ? sheetName : 'sheet1');
  workBook.Sheets[sheetName ? sheetName : 'sheet1'] = XLSX.utils.json_to_sheet(computedData);

  const workBookResult = XLSX.write(workBook, {
    bookType: bookType || 'xlsx',
    bookSST: true,
    type: 'binary'
  });

  let url = window.URL.createObjectURL(
    new Blob([buildArrayResult(workBookResult)], {
      type: 'application/octet-stream'
    })
  );

  download(url, fileName, sheetName);
};
